import { render } from "./CardMetrica.vue?vue&type=template&id=1fb4d5d1&scoped=true"
import script from "./CardMetrica.vue?vue&type=script&lang=js"
export * from "./CardMetrica.vue?vue&type=script&lang=js"

import "./CardMetrica.vue?vue&type=style&index=0&id=1fb4d5d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb4d5d1"]])

export default __exports__